<template>
  <div class="connect-credit">
    &copy; 2017-{{ thisYear }}
    <a href="http://agri-info-design.com/">Agri Info Design, Ltd.</a>
    <span v-if="isShowSpecifiedCommercialTransactionLaw"> / </span>
    <a href="https://agri-info-design.com/transactions/" target="_blank" v-if="isShowSpecifiedCommercialTransactionLaw">
      特定商取引法に基づく表記
    </a>
    /
    {{ version }}
  </div>
</template>

<script>
import ApplicationConfig from '@/lib/application-config'
import moment from 'moment'

export default {
  name: 'FooterComponent',
  props: ['isShowSpecifiedCommercialTransactionLaw'],
  computed: {
    thisYear() {
      return moment().year()
    },
    version() {
      return 'ver.' + ApplicationConfig.VERSION
    },
  },
}
</script>

<style scoped>
.connect-credit {
  font-size: small;
}
</style>
